<template>
  <div class="home_wrap">
    <div class="home">
      <page-header></page-header>
      <div class="home_content">
        <popup-component></popup-component>
        <banner-component></banner-component>

        <div class="home_content_donate_wrap">
          <div class="donate">
            <div class="donate_topText">
              <div class="donate_topText_title">후원안내</div>
              <div class="donate_topText_border"></div>
            </div>
            <image-component :infoType="'donationHome'"></image-component>
<!--            <div class="donate_content" >-->
<!--              <div class="donate_content_img" @click="movePage('/intro?tab=donation')"></div>-->
<!--            </div>-->
          </div>
        </div>

        <div class="news_wrap">
          <div class="news">
            <div class="news_topText">
              <div class="news_topText_title">뉴스</div>
              <!-- + 표시 뉴스탭 이동 -->
              <div class="news_topText_link" @click="movePage('/news')"></div>
              <div class="news_topText_border"></div>
            </div>
            <board-home-component :boardType="'homenews'"></board-home-component>
          </div>
        </div>
        <div class="donate_wrap">
          <div class="donate">
            <div class="donate_topText">
              <div class="donate_topText_title">나눔&배움</div>
              <div class="donate_topText_link" @click="movePage('/donate')"></div>
              <div class="donate_topText_borders"></div>
            </div>
            <board-home-component :boardType="'homedonate'"></board-home-component>
          </div>
        </div>
        <member-home-component :memberType="'homemember'"></member-home-component>
      </div>
      <page-footer></page-footer>
    </div>
  </div>
</template>

<script>

import BannerComponent from "@/components/banner/BannerComponent";
import BoardListComponent from "@/components/board/BoardListComponent";
import BoardHomeComponent from "@/components/board/BoardHomeComponent";
import MemberHomeComponent from "@/components/member/MemberHomeComponent";
import PopupComponent from "@/components/popup/PopupComponent";
import ImageComponent from "@/components/information/ImageComponent";

export default {
  name: 'Home',
  mixins: [],
  components: {
    ImageComponent,
    PopupComponent, MemberHomeComponent, BoardHomeComponent, BoardListComponent, BannerComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    openModal(name) {
      this.$modal.show(name);
    },

    movePage(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(path);
    },
  },
  watch: {},
}
</script>
